import React, { FC } from 'react';
import { ContainerLarge } from '../../components/base/grid';
import ForgotPasswordComponent from '../../components/myPost/forgotPassword';
import pageWrapper from '../../hoc/pageWrapper';
import IMyShipmentsForgotPasswordViewModel from '../../interfaces/myShipments/myShipmentsForgotPassword';

interface Props {
	page: IMyShipmentsForgotPasswordViewModel;
}

const MyShipmentsForgotPassword: FC<Props> = ({ page }) => {
	return (
		<ContainerLarge>
			<ForgotPasswordComponent page={page} />
		</ContainerLarge>
	);
};

export default pageWrapper(MyShipmentsForgotPassword);
